// Event types: emoji, short label and colour token, from values like "KL🥩" or "Blåtur🌍"

export const TYPE_COLORS = {
  KL: 'var(--color-kl)',
  Vino: 'var(--color-vino)',
  'Blåtur': 'var(--color-blatur)',
  KD: 'var(--color-kd)',
  'Julegrøt': 'var(--color-julegrot)',
  Julebord: 'var(--color-julebord)',
  Fitness: 'var(--color-fitness)',
};

export function typeInfo(type = '') {
  const emoji = (type.match(/\p{Extended_Pictographic}️?/u) || [''])[0];
  const label = type.replace(emoji, '').trim();
  return { emoji, label, color: TYPE_COLORS[label] || 'var(--accent)' };
}

// "2026 Q3" -> last day of that quarter
export function quarterEndDate(kvartal = '') {
  const [year, q] = kvartal.split(' ');
  const n = parseInt((q || '').replace('Q', ''), 10);
  if (!year || !n) return null;
  return new Date(parseInt(year, 10), n * 3, 0, 23, 59, 59);
}
